import { render, staticRenderFns } from "./SelectSeats.vue?vue&type=template&id=15a6e8e4"
import script from "./SelectSeats.vue?vue&type=script&lang=ts"
export * from "./SelectSeats.vue?vue&type=script&lang=ts"
import style0 from "./SelectSeats.vue?vue&type=style&index=0&id=15a6e8e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports